/**
 * Repr�sente un sch�ma de tableau
 */
export class SchemaTableauModel {
    Colonnes: SchemaTableauColonneModel[];
}

/**
 * Repr�sente une donn�e de tableau
 */
export class DonneeTableauModel {
    Colonnes: DonneeTableauColonneModel[];
    CssClass: string;
}

/**
 * Repr�sente une donn�e de colonne de tableau
 */
class DonneeTableauColonneModel {
    Libelle: string;
    Valeur: any;
    Type: string;
}

/**
 * Repr�sente un sch�ma de colonne de tableau
 */
class SchemaTableauColonneModel {
    EnTete: string;
    Nom: string;
    Trier: boolean;
    Type: string;
}